/**
 * List of child routes (like pop-over routes, ...)
 */
export default {
  CONTACT: {
    id: 'CONTACT',
    fr: ':contactUid',
    en: ':contactUid',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/PopOver/ContactPopOver'),
  },
  MEDIA: {
    id: 'MEDIA',
    fr: ':mediaUid',
    en: ':mediaUid',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/PopOver/MediaPopOver'),
  },
  PRESS_RELEASE: {
    id: 'PRESS_RELEASE',
    fr: ':pressReleaseUid',
    en: ':pressReleaseUid',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/PopOver/MediaPopOver'),
  },
};
